import { HttpInterceptorFn } from "@angular/common/http";

export const defaultHeadersInterceptor: HttpInterceptorFn = (req, next) => {
    // detect if the request url contains /admin/images

    if ((req.url.includes("/admin/images") || req.url.includes("/admin/files")) && req.method === "POST") {
        req = req.clone({
            setHeaders: {
                Accept: "application/json",
            },
        });
        return next(req);
    } else {
        req = req.clone({
            setHeaders: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        return next(req);
    }
};
